<div
  class="tw-p-4 tw-bg-white tw-flex tw-flex-col tw-gap-4"
  [class.date-range-picker-content--compact-mobile]="compactCalendarOnMobile()"
>
  <div class="tw-flex tw-gap-8 drp-calendars-row">
    <div class="tw-flex-1 drp-calendar drp-calendar--primary">
      <div class="tw-grid tw-grid-cols-3 tw-items-center tw-mb-2 tw-gap-1">
        <div class="tw-flex tw-justify-start">
          <button
            type="button"
            (click)="prevMonth()"
            class="tw-p-1 tw-rounded hover:tw-bg-gray-100 tw-text-gray-600"
            aria-label="Previous month"
          >
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.8572 4.81378H3.90239L6.52282 2.06273C6.63197 1.95206 6.71903 1.81967 6.77892 1.6733C6.83881 1.52692 6.87034 1.36949 6.87166 1.21019C6.87298 1.05088 6.84406 0.892898 6.7866 0.745452C6.72914 0.598006 6.64428 0.46405 6.53698 0.351401C6.42968 0.238753 6.30209 0.149667 6.16164 0.0893417C6.0212 0.0290167 5.87072 -0.001339 5.71898 4.52994e-05C5.56724 0.0014296 5.41728 0.0345265 5.27786 0.0974048C5.13843 0.160283 5.01233 0.251684 4.90691 0.366273L0.335739 5.16531C0.229315 5.27676 0.144878 5.40916 0.0872666 5.55491C0.0296551 5.70067 0 5.85693 0 6.01474C0 6.17255 0.0296551 6.32881 0.0872666 6.47457C0.144878 6.62033 0.229315 6.75273 0.335739 6.86417L4.90691 11.6632C5.12244 11.8818 5.41111 12.0027 5.71075 12C6.01039 11.9972 6.29702 11.871 6.5089 11.6486C6.72078 11.4262 6.84097 11.1252 6.84357 10.8107C6.84618 10.4961 6.73099 10.193 6.52282 9.96675L3.90239 7.2133H14.8572C15.1603 7.2133 15.451 7.0869 15.6653 6.8619C15.8796 6.6369 16 6.33174 16 6.01354C16 5.69535 15.8796 5.39018 15.6653 5.16519C15.451 4.94019 15.1603 4.81378 14.8572 4.81378Z" fill="#111928"/>
            </svg>
          </button>
        </div>
        <span class="tw-min-w-0 tw-text-center tw-text-xs tw-font-bold tw-text-gray-900 tw-font-inter">{{ monthLabel(leftMonthDate) }}</span>
        @if (compactCalendarOnMobile()) {
          <div class="tw-flex tw-justify-end tw-items-center">
            <span class="drp-month-nav__spacer-when-desktop tw-pointer-events-none tw-size-8 tw-shrink-0" aria-hidden="true"></span>
            <div class="drp-month-nav__next-when-mobile tw-flex tw-justify-end tw-items-center">
              <button
                type="button"
                (click)="nextMonth()"
                class="tw-p-1 tw-rounded hover:tw-bg-gray-100 tw-text-gray-600"
                aria-label="Next month"
              >
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.913 6.45783C15.9995 6.23906 16.0222 5.99833 15.978 5.76609C15.9339 5.53386 15.8249 5.32055 15.665 5.15317L11.0933 0.365411C10.9878 0.251091 10.8617 0.159906 10.7223 0.0971757C10.5828 0.0344453 10.4329 0.00142624 10.2811 4.51929e-05C10.1294 -0.00133585 9.97885 0.0289485 9.83839 0.0891316C9.69793 0.149315 9.57032 0.238191 9.463 0.350575C9.35569 0.462959 9.27083 0.596599 9.21336 0.743699C9.15589 0.890798 9.12697 1.04841 9.12829 1.20734C9.12961 1.36627 9.16114 1.52333 9.22104 1.66936C9.28094 1.81539 9.36801 1.94747 9.47717 2.05788L12.0991 4.80366H1.14293C0.839806 4.80366 0.549097 4.92977 0.334756 5.15423C0.120416 5.3787 0 5.68315 0 6.0006C0 6.31805 0.120416 6.62249 0.334756 6.84696C0.549097 7.07143 0.839806 7.19754 1.14293 7.19754H12.0991L9.47831 9.94212C9.36915 10.0525 9.28208 10.1846 9.22218 10.3306C9.16228 10.4767 9.13075 10.6337 9.12943 10.7927C9.12811 10.9516 9.15703 11.1092 9.2145 11.2563C9.27197 11.4034 9.35683 11.537 9.46415 11.6494C9.57146 11.7618 9.69907 11.8507 9.83953 11.9109C9.97999 11.9711 10.1305 12.0013 10.2823 12C10.434 11.9986 10.584 11.9656 10.7234 11.9028C10.8629 11.8401 10.989 11.7489 11.0944 11.6346L15.6661 6.84683C15.772 6.7354 15.8559 6.60322 15.913 6.45783Z"
                    fill="#111928"
                  />
                </svg>
              </button>
            </div>
          </div>
        } @else {
          <span class="tw-pointer-events-none tw-size-8 tw-shrink-0" aria-hidden="true"></span>
        }
      </div>
      <div class="drp-month-grid tw-grid tw-grid-cols-7 tw-text-center tw-px-2">
        @for (wd of weekDays(); track wd) {
          <div class="tw-text-xs tw-font-semibold tw-text-gray-500 tw-py-2 tw-px-1">{{ wd }}</div>
        }
        @for (item of getDaysForMonth(leftMonthDate); track item.date.getTime()) {
          <div
            class="day-cell tw-min-w-9"
            [ngxTippy]="
              item.isCurrentMonth &&
              (isDayBlockedByClosedExceptionRange(item.date) || (isDayBlockedByAllowedWeekDays(item.date) && !isBeforeMinSelectableDate(item.date)))
                ? 'Closed'
                : undefined
            "
            [tippyProps]="closedExceptionDayTippyProps"
          >
            <button
              type="button"
              [class.tw-pointer-events-none]="
                item.isCurrentMonth && (isDayBlockedByClosedExceptionRange(item.date) || isDayBlockedByAllowedWeekDays(item.date))
              "
              (click)="item.isCurrentMonth && !isDateDisabled(item.date) && selectDay(item.date)"
              [disabled]="item.isCurrentMonth && isDateDisabled(item.date)"
              [class.tw-cursor-default]="!item.isCurrentMonth || isDateDisabled(item.date)"
              [class.tw-cursor-pointer]="item.isCurrentMonth && !isDateDisabled(item.date)"
              [class.tw-text-gray-400]="
                !item.isCurrentMonth ||
                (item.isCurrentMonth && isDateDisabled(item.date) && !isDayClosedHighlight(item.date))
              "
              [class.hover:tw-bg-gray-100]="item.isCurrentMonth && !isDateDisabled(item.date) && !isSelected(item.date) && !isInRange(item.date)"
              [class.tw-bg-blue-600]="item.isCurrentMonth && !isDateDisabled(item.date) && isSelected(item.date)"
              [class.tw-text-white]="item.isCurrentMonth && !isDateDisabled(item.date) && isSelected(item.date)"
              [class]="
                'tw-w-full tw-h-full tw-text-xs tw-font-inter disabled:tw-pointer-events-none ' +
                dayButtonRoundingClass(item.date, item.isCurrentMonth)
              "
              [class.tw-bg-gray-100]="
                item.isCurrentMonth && isInRange(item.date) && !isSelected(item.date) && !isDayClosedHighlight(item.date)
              "
              [class.tw-bg-red-50]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-text-red-800]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-1]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-inset]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-red-200]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
            >
              {{ item.date.getDate() }}
            </button>
          </div>
        }
      </div>
    </div>
    <div class="tw-flex-1 tw-min-w-0 drp-calendar drp-calendar--secondary">
      <div class="tw-grid tw-grid-cols-3 tw-items-center tw-mb-2 tw-gap-1">
        <span class="tw-pointer-events-none tw-size-8 tw-shrink-0" aria-hidden="true"></span>
        <span class="tw-min-w-0 tw-text-center tw-text-sm tw-font-medium tw-text-gray-900">{{ monthLabel(rightMonthDate) }}</span>
        <div class="tw-flex tw-justify-end">
          <button
            type="button"
            (click)="nextMonth()"
            class="tw-p-1 tw-rounded hover:tw-bg-gray-100 tw-text-gray-600"
            aria-label="Next month"
          >
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.913 6.45783C15.9995 6.23906 16.0222 5.99833 15.978 5.76609C15.9339 5.53386 15.8249 5.32055 15.665 5.15317L11.0933 0.365411C10.9878 0.251091 10.8617 0.159906 10.7223 0.0971757C10.5828 0.0344453 10.4329 0.00142624 10.2811 4.51929e-05C10.1294 -0.00133585 9.97885 0.0289485 9.83839 0.0891316C9.69793 0.149315 9.57032 0.238191 9.463 0.350575C9.35569 0.462959 9.27083 0.596599 9.21336 0.743699C9.15589 0.890798 9.12697 1.04841 9.12829 1.20734C9.12961 1.36627 9.16114 1.52333 9.22104 1.66936C9.28094 1.81539 9.36801 1.94747 9.47717 2.05788L12.0991 4.80366H1.14293C0.839806 4.80366 0.549097 4.92977 0.334756 5.15423C0.120416 5.3787 0 5.68315 0 6.0006C0 6.31805 0.120416 6.62249 0.334756 6.84696C0.549097 7.07143 0.839806 7.19754 1.14293 7.19754H12.0991L9.47831 9.94212C9.36915 10.0525 9.28208 10.1846 9.22218 10.3306C9.16228 10.4767 9.13075 10.6337 9.12943 10.7927C9.12811 10.9516 9.15703 11.1092 9.2145 11.2563C9.27197 11.4034 9.35683 11.537 9.46415 11.6494C9.57146 11.7618 9.69907 11.8507 9.83953 11.9109C9.97999 11.9711 10.1305 12.0013 10.2823 12C10.434 11.9986 10.584 11.9656 10.7234 11.9028C10.8629 11.8401 10.989 11.7489 11.0944 11.6346L15.6661 6.84683C15.772 6.7354 15.8559 6.60322 15.913 6.45783Z" fill="#111928"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="drp-month-grid tw-grid tw-grid-cols-7 tw-text-center tw-px-2">
        @for (wd of weekDays(); track wd) {
          <div class="tw-text-xs tw-font-semibold tw-text-gray-500 tw-py-2 tw-px-1">{{ wd }}</div>
        }
        @for (item of getDaysForMonth(rightMonthDate); track item.date.getTime()) {
          <div
            class="tw-min-w-9 day-cell"
            [ngxTippy]="
              item.isCurrentMonth &&
              (isDayBlockedByClosedExceptionRange(item.date) || (isDayBlockedByAllowedWeekDays(item.date) && !isBeforeMinSelectableDate(item.date)))
                ? 'Closed'
                : undefined
            "
            [tippyProps]="closedExceptionDayTippyProps"
          >
            <button
              type="button"
              [class.tw-pointer-events-none]="
                item.isCurrentMonth && (isDayBlockedByClosedExceptionRange(item.date) || isDayBlockedByAllowedWeekDays(item.date))
              "
              (click)="item.isCurrentMonth && !isDateDisabled(item.date) && selectDay(item.date)"
              [disabled]="item.isCurrentMonth && isDateDisabled(item.date)"
              [class.tw-cursor-default]="!item.isCurrentMonth || isDateDisabled(item.date)"
              [class.tw-cursor-pointer]="item.isCurrentMonth && !isDateDisabled(item.date)"
              [class.tw-text-gray-400]="
                !item.isCurrentMonth ||
                (item.isCurrentMonth && isDateDisabled(item.date) && !isDayClosedHighlight(item.date))
              "
              [class.hover:tw-bg-gray-100]="item.isCurrentMonth && !isDateDisabled(item.date) && !isSelected(item.date) && !isInRange(item.date)"
              [class.tw-bg-blue-600]="item.isCurrentMonth && !isDateDisabled(item.date) && isSelected(item.date)"
              [class.tw-text-white]="item.isCurrentMonth && !isDateDisabled(item.date) && isSelected(item.date)"
              [class]="
                'tw-w-full tw-h-full tw-text-xs tw-font-inter disabled:tw-pointer-events-none ' +
                dayButtonRoundingClass(item.date, item.isCurrentMonth)
              "
              [class.tw-bg-gray-100]="
                item.isCurrentMonth && isInRange(item.date) && !isSelected(item.date) && !isDayClosedHighlight(item.date)
              "
              [class.tw-bg-red-50]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-text-red-800]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-1]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-inset]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
              [class.tw-ring-red-200]="item.isCurrentMonth && isDayClosedHighlight(item.date)"
            >
              {{ item.date.getDate() }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
<!-- TODO: Uncomment this when the indefinite option is needed -->
  <!-- @if (showIndefiniteOption()) {
    <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-800 tw-font-inter">
      <input
        type="checkbox"
        class="tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-accent-blue-600 focus:tw-outline-none"
        [checked]="runsIndefinitely()"
        (change)="runsIndefinitely.set($any($event.target).checked); rangeEnd.set(null)"
      />
      My event runs indefinitely
    </label>
  } -->
  <div class="tw-flex tw-flex-wrap lg:tw-flex-nowrap tw-gap-4">
    <button
      type="button"
      (click)="reset()"
      class="tw-flex-1 tw-py-2 tw-px-4 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-text-gray-800 tw-text-xs tw-font-medium hover:tw-bg-gray-50"
    >
      Reset
    </button>
    <button
      type="button"
      (click)="apply()"
      class="tw-flex-1 tw-py-2 tw-px-4 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-xs tw-font-medium hover:tw-bg-blue-700"
    >
      Apply
    </button>
  </div>
</div>
